// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// 1. Importez le détecteur
import LanguageDetector from 'i18next-browser-languagedetector'; 

import fr from './locales/fr.json';
import en from './locales/en.json';
import ht from './locales/ht.json';

i18n
  // 2. Utilisez le détecteur (avant initReactI18next)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ht: { translation: ht },
    },
    // Le détecteur remplacera 'lng' si une langue est trouvée
    // On peut retirer 'lng: 'fr'' car il est géré par LanguageDetector/fallbackLng.
    // Laissez le commentaire ci-dessous si vous voulez spécifier les langues supportées.
    supportedLngs: ['fr', 'en', 'ht'], 
    fallbackLng: 'fr', // Si aucune des langues supportées n'est trouvée, il utilise 'fr'
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'], // Ordre de détection
      caches: ['localStorage'], // Stocke la dernière langue dans localStorage
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;